import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { UserService } from './user.service';

@Injectable()
export class RoleService extends UserService {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'roles/';
  }
}
